// TODO this should be moved to some common library which can be used across multiple projects
export type ToStringFn = () => string;
export type ToStringObj = { toString: ToStringFn };

export type EntityCrudFactoryResult = {
  toString: ToStringFn;
  VIEW: ToStringObj;
  CREATE: ToStringObj;
  EDIT: ToStringObj;
  REMOVE: ToStringObj;
};

export const entityCrudFactory = (key: string): EntityCrudFactoryResult => ({
  toString: (): string => `${key}`,
  VIEW: { toString: (): string => `${key}.view` },
  CREATE: { toString: (): string => `${key}.create` },
  EDIT: { toString: (): string => `${key}.edit` },
  REMOVE: { toString: (): string => `${key}.remove` },
});

export const PERMISSION_TYPE = Object.freeze({
  MODULE: {
    toString: (): string => 'module',
    SHIPPER: {
      toString: (): string => 'module.shipper',
    },
    HAULIER: {
      toString: (): string => 'module.haulier',
    },
    SHIPPER_CONTRACTOR: {
      toString: (): string => 'module.subcontractor',
    },
    SUPER_ADMIN: {
      toString: (): string => 'module.super-admin',
    },
  },
});
